module.exports = __webpack_public_path__ + "static/media/Section 1 - Background.14b074a2.png";